import { useState } from "react";
import axios from "axios";
import { TbBuilding, TbMail, TbLock, TbEye, TbEyeOff } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AgencyContext } from "../clients/utils/AgencyContext";

const API = "https://api.komorotel.com/api";

export default function AgencyLogin() {
  const navigate = useNavigate();
  const [form, setForm]       = useState({ email: "", password: "" });
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);
  const { refetch } = useContext(AgencyContext);


  const handleChange = (e) => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
    setError(null);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await axios.post(`${API}/agency/login`, form, { withCredentials: true });
      await refetch(); // ← recharge agency dans le contexte
      navigate("/agency");
    } catch (err) {
      setError(err.response?.data?.message || "Identifiants incorrects.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">

        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-12 h-12 rounded-2xl bg-[var(--k-green-soft)] flex items-center justify-center mb-3">
            <TbBuilding className="text-[var(--k-green)]" size={24} />
          </div>
          <h1 className="text-xl font-medium text-gray-900">Espace agence</h1>
          <p className="text-sm text-gray-400 mt-1">Komorotel — Back-office partenaires</p>
        </div>

        {/* Card */}
        <div className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm">

          {error && (
            <div className="mb-4 px-3 py-2.5 rounded-xl bg-red-50 border border-red-100 text-sm text-red-600">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">

            {/* Email */}
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-medium text-gray-500">Email</label>
              <div className="relative">
                <TbMail
                  size={16}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                />
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="agence@email.com"
                  required
                  className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-200 rounded-xl outline-none focus:border-[var(--k-green)] focus:ring-2 focus:ring-[rgb(var(--k-green-rgb)/0.1)] transition"
                />
              </div>
            </div>

            {/* Password */}
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-medium text-gray-500">Mot de passe</label>
              <div className="relative">
                <TbLock
                  size={16}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                />
                <input
                  type={showPwd ? "text" : "password"}
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="••••••••"
                  required
                  className="w-full pl-9 pr-10 py-2.5 text-sm border border-gray-200 rounded-xl outline-none focus:border-[var(--k-green)] focus:ring-2 focus:ring-[rgb(var(--k-green-rgb)/0.1)] transition"
                />
                <button
                  type="button"
                  onClick={() => setShowPwd(s => !s)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition"
                >
                  {showPwd ? <TbEyeOff size={16} /> : <TbEye size={16} />}
                </button>
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 mt-1 rounded-xl bg-[var(--k-green)] text-white text-sm font-medium hover:bg-[var(--k-green-hover)] transition disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {loading ? "Connexion..." : "Se connecter"}
            </button>

          </form>
        </div>

        <p className="text-center text-xs text-gray-400 mt-6">
          Komorotel © {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}